export const TEAMS_PATH = '/diam/teams';
